import CanvasHeader from "./CanvasHeader";
import CanvasMain from "./CanvasMain";

export default function Canvas() {
    return (
        <div className="pl-8 pr-10 py-8 flex-grow w-auto relative overflow-y-auto">
            <CanvasHeader />
            <CanvasMain />
        </div>
    )
}